import Vue from "vue";
import Router from "vue-router";
import { Capacitor } from "@capacitor/core";
import store from "../store";

import Landing from "../views/Landing.vue";
import Login from "../views/Login.vue";
import Calendar from "../views/Calendar.vue";
import Groups from "../views/Groups.vue";
import Profile from "../views/Profile.vue";
import InviteAccept from "../views/InviteAccept.vue";
import CookiesPolicy from "../views/info/cookiesPolicy.vue";
import LegalNotice from "../views/info/legalNotice.vue";
import PrivacyPolicy from "../views/info/privacyPolicy.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    // RUTAS PÚBLICAS
    {
      path: "/",
      name: "Landing",
      component: Landing,
      meta: { public: true, webOnly: true }
    },
    {
      path: "/login",
      component: Login,
      meta: { public: true }
    },
    {
      path: "/invite/:token",
      component: InviteAccept,
      meta: { public: true }
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: PrivacyPolicy,
      meta: { public: true }
    },
    {
      path: "/cookies-policy",
      name: "cookies-policy",
      component: CookiesPolicy,
      meta: { public: true }
    },
    {
      path: "/legal-notice",
      name: "legal-notice",
      component: LegalNotice,
      meta: { public: true }
    },

    // RUTAS PRIVADAS
    { path: "/calendar", component: Calendar },
    { path: "/groups", component: Groups },
    { path: "/profile", component: Profile },
    {
      path: "/requests",
      name: "Requests",
      component: () => import("@/views/Requests.vue")
    },

    // DEFAULT
    { path: "*", redirect: "/calendar" }
  ]
});

router.beforeEach(async (to, from, next) => {
  // Inicializar listener de auth una sola vez
  if (!store.getters["auth/inited"]) {
    await store.dispatch("auth/initAuth");
  }

  const authed = store.getters["auth/isAuthed"];
  const isPublic = to.matched.some(route => route.meta && route.meta.public);
  const isWebOnly = to.matched.some(route => route.meta && route.meta.webOnly);

  // La landing es solo web; en la app nativa se conserva el login como entrada.
  if (isWebOnly && Capacitor.isNativePlatform()) {
    return next("/login");
  }

  // No autenticado → solo rutas públicas
  if (!authed && !isPublic) {
    return next("/login");
  }

  // Autenticado → no volver a login/landing
  if (authed && (to.path === "/login" || to.path === "/")) {
    return next("/calendar");
  }

  return next();
});

export default router;
